import { render, staticRenderFns } from "./styles.vue?vue&type=template&id=104f8f94&scoped=true&"
import script from "./styles.vue?vue&type=script&lang=js&"
export * from "./styles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104f8f94",
  null
  
)

export default component.exports